// extracted by mini-css-extract-plugin
export default {"content":"pageNotFound_content__VRwRi","subtitle":"pageNotFound_subtitle__i0iX9"};